module.exports = __webpack_public_path__ + "img/s-cross-gris-agata.743a49ee.png";